export const REASONS_TO_BOOK = [
  {
    image: "/images/social-proof-world.png",
    title: "We know adventure",
    details:
      "Experience the trip of a lifetime organized by a team of travel specialists who combine knowledge and passion for adventure travel.",
  },
  {
    image: "/images/social-proof-compass.png",
    title: "Self-guided Specialists",
    details:
      "Combine the freedom of travelling on your own with the confidence that all of the logistics are taken care of.",
    tourType: 78,
    groupType: 788,
  },
  {
    image: "/images/social-proof-compass.png",
    title: "Custom Guided Trips",
    details:
      "Experience a private trip led by a highly-vetted local guide taking you to places most travellers never see.",
    tourType: 57,
    groupType: 788,
  },
  {
    image: "/images/social-proof-compass.png",
    title: "Small Group Adventures",
    details:
      "Join like-minded travellers to safely and confidently experience all the things that make our world worth exploring.",
    tourType: 57,
    groupType: 789,
  },
  {
    image: "/images/social-proof-list.png",
    title: "Packed with Inclusions",
    details:
      "We take care of accommodations, luggage transfers, gear rentals, and more - so you can focus on making memories.",
  },
  {
    image: "/images/badge.png",
    title: "World Class Support",
    details:
      "Have peace of mind for when travel plans change with our hassle-free booking process and unbeatable support.",
  },
]
